/* eslint-disable */
import isNumber from '@dcode/is/number/number';

export const getScrollTop = (element) => {
	return (
		element && isNumber(element.scrollTop)
		? element.scrollTop
		: window.pageYOffset || 0
	);
};

export default getScrollTop;
